import React from "react";

import { Trans } from "@lingui/macro";

import {
  Dialog,
  CloseButton,
  Container,
  ContentContainer,
  Header,
} from "@app/common/access/ShareReport/styles";

import { ModalTitle } from "@rui/Modal";

import SendViaMenu from "./SendViaMenu";

interface SendViaMenuDialogProps {
  open: boolean;
  onClose: () => void;
}
const SendViaMenuDialog = ({ open, onClose }: SendViaMenuDialogProps) => {
  return (
    <Dialog fullWidth open={open} onClose={onClose}>
      <Container>
        <Header sx={{ border: "none" }}>
          <ModalTitle>
            <Trans>Push to...</Trans>
          </ModalTitle>
          <CloseButton onClick={onClose} />
        </Header>
        <ContentContainer sx={{ paddingBottom: 2 }}>
          <SendViaMenu onProviderDialogClose={onClose} />
        </ContentContainer>
      </Container>
    </Dialog>
  );
};

export default SendViaMenuDialog;
